var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n    .arrow-icon {\n      fill: none;\n      stroke-width: 10.1188;\n      stroke-linecap: round;\n    }\n  "),React.createElement("g",{"id":"Group_1784","transform":"translate(1 1.414)","key":1},[React.createElement("path",{"id":"Path_4","className":"arrow-icon","d":"M11.5,41.9h93.4","key":0}),React.createElement("path",{"id":"Path_5","className":"arrow-icon","d":"M73.1,7.9L106.3,42L73.1,75.1","key":1})])]);
}

ArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 119.7 85.8","style":{"enableBackground":"new 0 0 119.7 85.8"},"xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
